<template>
  <div class="container">
    <div class="block1">
      <div class="profitRate-wrap">
        <span class="profitRate">+ {{profitRate}}%</span>
        <van-loading v-if="loading" class="balance-spinner" type="spinner" size="20"/>
      </div>
      <span v-if="approved || userType === 2" class="tips">{{ $t("tradingPage.miningWorking") }}</span>
      <span v-else class="tips">{{ $t("tradingPage.miningNotWorking") }}</span>
      <div class="balance">(<img src="../assets/images/usdtlogo.png" width="20">&nbsp;USDT {{$t('tradingPage.balance')}}: {{Math.floor(usdtvalue)}})</div>
      <img class="Mining-machine" src="../assets/images/mining-2.png" @click="openModifier">
      <div class="rule" @click="ruleVisible = true">{{$t('tradingPage.rule')}}</div>
    </div>
    <div class="block2">
      <div class="block2-1">
        <div class="block2-1-1">
          <span>{{ $t("tradingPage.tradingProfit") }}</span>
          <span>{{ $t("tradingPage.settlementRule") }}</span>
        </div>
        <div class="block2-1-2" @click="$router.push('/profitList')">
          {{ $t("tradingPage.viewAll") }}
        </div>
      </div>
      <div v-for="elem of data" :key="elem.id" class="profit-item">
        <img src="../assets/images/47update.png">
        <div>
          <span>{{elem.amount}} USDT</span>
          <span>{{ $t("tradingPage.quantifyingTransactionRevenue") }}</span>
        </div>
        <van-button round color="linear-gradient(to right, #F0A500, #4A3933)" style="padding: 0 18px;" hairline size="small" :disabled="elem.received || receiving" @click="receive(elem)">{{ $t(`tradingPage.${elem.received ? 'received':'receive'}`) }}</van-button>
      </div>
    </div>
    <van-popup v-model="ruleVisible" style="background-color: #d6b593">
      <div class="block3">
          <div class="block3-1">
            {{$t('tradingPage.rules')}}
          </div>
          <div class="block3-2">
            <div class="td" style="width:30%;">{{$t('teamPage.level')}}</div>
            <div class="td" style="width:33%;">USDT</div>
            <div class="td" style="width:37%;">{{$t('tradingPage.profit')}}</div>
            <template v-for="(elem, index) of cloudMiningDailyInterestRate">
                <div class="td" :key="elem.id" style="width:30%;">lv.{{index + 1}}</div>
                <div v-if="elem.length === 2" class="td" :key="elem.id" style="width:35%;">> {{elem[0]}}</div>
                <div v-else class="td" :key="elem.id" style="width:40%;">{{elem[0]}} - {{elem[1]}}</div>
                <div v-if="elem.length === 2" class="td" :key="elem.id" style="width:30%;">{{Number.parseFloat((elem[1] * 100).toFixed(2))}}%</div>
                <div v-else class="td" :key="elem.id" style="width:30%;">{{Number.parseFloat((elem[2] * 100).toFixed(2))}}%</div>
            </template>
          </div>
      </div>
    </van-popup>
    <van-popup v-model="modifierVisible" style="width:324px;">
      <div style="text-align: center;padding: 10px;">修改器<van-icon name="edit" /></div>
      <van-form>
        <van-field
          v-model="modifierFormObj.usdtvalue"
          label="钱包余额"
          placeholder="请输入USDT余额"
          type="number"
        />
        <van-list style="max-height: 236px;overflow-y: auto;">
          <van-cell title="收益列表"><van-button size="small" type="primary" @click="addRecordVisible = true">添加记录</van-button></van-cell>
          <van-cell v-for="item in modifierFormObj.data" :key="item" :title="`${item.amount}（${item.received ? '已领取':'未领取'}）`" ><van-button size="small" type="danger" @click="delRecord(item.id)">删除记录</van-button></van-cell>
        </van-list>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" @click="saveChanges">保存修改</van-button>
        </div>
      </van-form>
    </van-popup>
    <van-popup v-model="addRecordVisible" style="width:300px;">
      <van-form @submit="addRecord" label-width="50">
          <div style="text-align: center;padding: 10px;">添加记录<van-icon name="edit" /></div>
          <van-field
            v-model="recordFormObj.amount"
            label="金额"
            placeholder="请输入金额"
            type="number"
          />
          <van-field name="radio" label="状态">
          <template #input>
            <van-radio-group v-model="recordFormObj.received" direction="horizontal">
              <van-radio :name="true">已领取</van-radio>
              <van-radio :name="false">未领取</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">保存</van-button>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: 'trading',
  data() {
    return {
      data: [],
      cloudMiningDailyInterestRate: [[1,100,0.009],[100,500,0.012],[500,2000,0.014],[2000,5000,0.019],[5000,20000,0.026],[20000,50000,0.035],[50000,150000,0.04],[150000,0.05]],
      approved: false,
      userType: 1,
      usdtvalue: '0',
      ruleVisible: false,
      loading: false,
      receiving: false,
      modifierVisible: false,
      modifierFormObj: {
        usdtvalue: '0',
        data: []
      },
      addRecordVisible: false,
      recordFormObj: {
        amount: '0',
        received: true
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem('token');
    this._fetch();
    this._balanceOf();
  },
  methods: {
    _fetch() {
        this.apiV1({
            method: 'get',
            url: '/trading',
            headers: {'Authorization': this.token}
        }).then(response => {
            const { success, data } = response.data;
            if (success) {
                this.data = data.data;
                this.cloudMiningDailyInterestRate = data.cloudMiningDailyInterestRate;
                this.approved = data.approved;
                this.userType = data.type;
            }
        })
    },
    _balanceOf() {
      this.loading = true;
      this.apiV1({
            method: 'get',
            url: '/balanceOf',
            headers: {'Authorization': this.token}
        }).then(response => {
            const { success, data } = response.data;
            if (success) {
                this.usdtvalue = data.usdtvalue;
            }
        }).finally(() => this.loading = false);
    },
    receive(row) {
      this.receiving = true;
      this.apiV1({
          method: 'post',
          url: '/trading/receive',
          data: {
            id: row.id
          },
          headers: {'Authorization': this.token}
      }).then(response => {
          const { success } = response.data;
          if (success) {
            this.$toast.success(this.$t("tradingPage.received"));
            this._fetch();
          }
      }).finally(() => this.receiving = false);
    },
    openModifier() {
      if (this.userType !== 2) {
        return;
      }
      this.modifierFormObj = {
        usdtvalue: this.usdtvalue,
        data: [...this.data]
      };
      this.modifierVisible = true;
    },
    addRecord() {
      this.modifierFormObj.data.unshift({
        id: Date.now(),
        ...this.recordFormObj
      });
      this.addRecordVisible = false;
      this.$toast.success('已添加');
    },
    delRecord(id) {
      this.$dialog.confirm({
        title: '提示',
        message: '确认删除？',
      })
        .then(() => {
          this.modifierFormObj.data = this.modifierFormObj.data.filter(elem => elem.id !== id);
          this.$toast.success('已删除');
        })
    },
    saveChanges() {
      this.usdtvalue = this.modifierFormObj.usdtvalue;
      this.data = [...this.modifierFormObj.data];
      this.modifierVisible = false;
      this.$toast.success('已保存修改');
    }
  },
  computed: {
    profitRate() {
      if (this.approved || this.userType === 2) {
        for (const range of this.cloudMiningDailyInterestRate) {
          if (range.length === 2) {
            if (this.usdtvalue >= range[0]) {
              return Number.parseFloat((range[1] * 100).toFixed(2));
            }
          } else {
            if (this.usdtvalue >= range[0] && this.usdtvalue < range[1]) {
              return Number.parseFloat((range[2] * 100).toFixed(2));
            }
          }
        }
      }
      return 0;
    }
  }
}
</script>
<style scoped lang="less">
.container {
  padding: @nav-bar-height 0 @tabbar-height;
}
.block1 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6.88rem;
  .profitRate-wrap {
    display: flex;
    align-items: center;
    .profitRate {
      font-size: 6.933rem;
    }
    .balance-spinner {
      margin-left: 6px;
    }
  }
  .tips {
    font-size: 3.733rem;
    margin: 1.5rem 0;
  }
  .balance {
    display: flex;
    align-items: center;
  }
  img.Mining-machine {
    width: 80rem;
    margin: 6.4rem 0 -2.933rem;
  }
  .rule {
    position: absolute;
    right: 0;
    top: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background-color: @app-theme-color4;
    border: 1px solid #814000;
    border-right-width: 0;
    z-index: 9;
    box-shadow: 0 0 4.267rem hsl(0deg 0% 47% / 27%);
    border-radius: 2rem 0 0 2rem;
  }
}
.block2 {
  padding: 6rem 3.467rem 3.888rem;
  border: 0.267rem solid;
  border-radius: 4rem;
  .block2-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .block2-1-1 {
      display: flex;
      flex-direction: column;
      span:nth-child(1) {
        font-size: 6.933rem;
        font-weight: bold;
      }
      span:nth-child(2) {
        font-size: 3.2rem;
      }
    }
    .block2-1-2 {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 2rem;
      background-color: @app-theme-color4;
      border: 1px solid #814000;
      border-right-width: 0;
      right: -3.467rem;
      // top: 8rem;
      z-index: 9;
      box-shadow: 0 0 4.267rem hsl(0deg 0% 47% / 27%);
      border-radius: 2rem 0 0 2rem;
    }
  }
}
.profit-item {
  background-color: @app-theme-color4;
    border: 1px solid #814000;
    border-radius: 3.888rem;
    padding: 2.133rem;
    margin: 3.2rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 10.88rem;
      margin-right: 2.133rem;
    }
    >div {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
}
.block3 {
  background-color: #d6b593;
  .block3-1 {
    border: 0.267rem solid #814000;
    border-radius: 3.733rem;
    padding: 3.888rem;
    margin: 5.333rem 0 4rem;
    display: flex;
    flex-direction: column;
    font-size: 2.933rem;
    text-align: center;
    color: #fffce3;
  }
  .block3-2 {
    border: 0.267rem solid #814000;
    color: #814000;
    padding: 3.888rem;
    width: 85rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .th, .td {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30%;
        height: 8rem;
        border-radius: 0.8rem;
    }
    .th {
        color: #d6b593;
        background-color: @app-theme-color1;
    }
  }
}
</style>
